import { createAction } from "@reduxjs/toolkit";

export const requestStream = createAction<string>('rfs/requestStream') // string in for CurrencyPair